var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodeContactMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58482 9.55725C8.33929 9.03399 8.16518 8.54651 8.16518 8.02325C8.16518 7.5 8.51339 6.97675 8.92411 6.59213C9.64732 5.93023 10.0625 4.95081 10.0625 3.83721C10.0625 1.77996 8.81697 0 6.60714 0C4.39732 0 3.15179 1.77996 3.15179 3.83721C3.15179 4.95528 3.57143 5.89446 4.29018 6.59213C4.70982 6.97675 5.04911 7.5 5.04911 8.02325C5.04911 8.54651 4.83929 9.03399 3.62946 9.55725C1.76786 10.3265 0.0357143 11.2299 0 12.907C0 14.025 0.790178 15 1.82589 15H11.2991C12.3348 15 13.125 14.025 13.125 12.907C13.0893 11.2343 11.3661 10.3265 9.5625 9.55725H9.58482Z",
    fill: "#0D2045"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodeContactMaster);
export default __webpack_public_path__ + "static/media/nodeContactMaster.bacc92dd2242673ab01867b82d7dd96c.svg";
export { ForwardRef as ReactComponent };